import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgBrowse = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.55 10a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 .75.75M4.55 13a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 .75.75M12.91 5.25a5.96 5.96 0 1 0 0 11.921 5.96 5.96 0 0 0 0-11.921m-7.46 5.96a7.46 7.46 0 1 1 13.24 4.719l5.04 5.04a.75.75 0 1 1-1.06 1.061l-5.04-5.04A7.46 7.46 0 0 1 5.45 11.21"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgBrowse;
